module.exports = __webpack_public_path__ + "media/speech-bubbles/square-speech-bubble--no-foot--desktop-1014d23f.svg";